var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeMandal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13.5,
    height: 13.5,
    viewBox: "0 0 13.5 13.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0 13.5V3H3V0H10.5V6H13.5V13.5H7.5V10.5H6V13.5H0V13.5M1.5 12H3V10.5H1.5V12V12M1.5 9H3V7.5H1.5V9V9M1.5 6H3V4.5H1.5V6V6M4.5 9H6V7.5H4.5V9V9M4.5 6H6V4.5H4.5V6V6M4.5 3H6V1.5H4.5V3V3M7.5 9H9V7.5H7.5V9V9M7.5 6H9V4.5H7.5V6V6M7.5 3H9V1.5H7.5V3V3M10.5 12H12V10.5H10.5V12V12M10.5 9H12V7.5H10.5V9V9",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeMandal);
export default __webpack_public_path__ + "static/media/node-mandal.74d4c40ecad4a617ea3ba038cc81d2a5.svg";
export { ForwardRef as ReactComponent };